var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"listContainer"},[_c('self-building-square-spinner',{staticStyle:{"margin":"0 auto"},attrs:{"animation-duration":6000,"size":40,"color":"#3498db"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }